module.exports = __webpack_public_path__ + "static/media/jackpots-lvl0.70bd3302.png";